(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vg-resenas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var mqReducido = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mqEscritorio = window.matchMedia('(min-width: 990px)');

    function conMovimiento() {
      return !mqReducido.matches;
    }

    function enfocar(el) {
      if (!el) return;
      try {
        el.focus({ preventScroll: true });
      } catch (e) {
        el.focus();
      }
    }

    function escucharMq(mq, fn) {
      if (mq.addEventListener) mq.addEventListener('change', fn);
      else if (mq.addListener) mq.addListener(fn);
      return function () {
        if (mq.removeEventListener) mq.removeEventListener('change', fn);
        else if (mq.removeListener) mq.removeListener(fn);
      };
    }

    /* Enlace «12 reseñas» (snippets/vg-valoracion.liquid): baja con suavidad hasta #resenas de la
       misma página y deja el foco en el título de la sección. */
    if (!window.vgResenasEnlaces) {
      window.vgResenasEnlaces = true;
      document.addEventListener('click', function (evento) {
        if (evento.defaultPrevented || evento.button !== 0) return;
        if (evento.metaKey || evento.ctrlKey || evento.shiftKey || evento.altKey) return;
        var enlace = evento.target && evento.target.closest ? evento.target.closest('a[href*="#resenas"]') : null;
        if (!enlace) return;
        var url;
        try {
          url = new URL(enlace.href, window.location.href);
        } catch (e) {
          return;
        }
        if (url.hash !== '#resenas') return;
        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
        var destino = document.getElementById('resenas');
        if (!destino) return;
        evento.preventDefault();
        destino.scrollIntoView({ behavior: conMovimiento() ? 'smooth' : 'auto', block: 'start' });
        enfocar(destino.querySelector('[data-vg-foco]') || destino);
      });
    }

    if (!window.customElements || window.customElements.get('vg-resenas')) return;

    class VgResenas extends HTMLElement {
      constructor() {
        super();
        this.alPulsar = this.alPulsar.bind(this);
      }

      connectedCallback() {
        if (this.vgListo) return;
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.connectedCallback(), { once: true });
          return;
        }
        if (!this.isConnected) return;
        this.vgListo = true;
        this.vgLimpiar = [];
        this.lista = this.querySelector('[data-vg-lista]');
        this.items = Array.prototype.slice.call(this.querySelectorAll('[data-vg-item]'));
        this.classList.add('vg-resenas--js');

        this.addEventListener('click', this.alPulsar);
        this.vgLimpiar.push(() => this.removeEventListener('click', this.alPulsar));

        this.iniciarBarras();
        this.iniciarVerMas();
        this.iniciarCarrusel();
        this.iniciarMuro();
        this.iniciarFotos();
      }

      disconnectedCallback() {
        (this.vgLimpiar || []).forEach(function (fn) {
          fn();
        });
        this.vgLimpiar = [];
        this.vgListo = false;
      }

      alPulsar(evento) {
        var t = evento.target;
        if (!t || !t.closest) return;

        if (this.dialogo && this.dialogo.open) {
          if (t === this.dialogo || t.closest('[data-vg-cerrar]')) this.dialogo.close();
          return;
        }

        var foto = t.closest('[data-vg-foto]');
        if (foto) {
          if (!this.dialogo) return;
          if (evento.button !== 0 || evento.metaKey || evento.ctrlKey || evento.shiftKey || evento.altKey) return;
          evento.preventDefault();
          this.abrirFoto(foto);
          return;
        }

        if (t.closest('[data-vg-mas]')) return this.verMas();
        if (t.closest('[data-vg-anterior]')) return this.moverCarrusel(-1);
        if (t.closest('[data-vg-siguiente]')) return this.moverCarrusel(1);

        var leer = t.closest('[data-vg-leer]');
        if (leer) this.alternarTexto(leer);
      }

      /* Barras del reparto: se rellenan la primera vez que se ve el resumen */
      iniciarBarras() {
        var resumen = this.querySelector('[data-vg-resumen]');
        if (!resumen || !('IntersectionObserver' in window)) {
          this.classList.add('vg-resenas--visto');
          return;
        }
        var io = new IntersectionObserver(
          (entradas) => {
            if (
              entradas.some(function (e) {
                return e.isIntersecting;
              })
            ) {
              this.classList.add('vg-resenas--visto');
              io.disconnect();
            }
          },
          { threshold: 0.35 }
        );
        io.observe(resumen);
        this.vgLimpiar.push(function () {
          io.disconnect();
        });
      }

      /* «Ver más reseñas» (escritorio): enseña la siguiente tanda y lleva el foco a la primera nueva */
      iniciarVerMas() {
        this.botonMas = this.querySelector('[data-vg-mas]');
        this.paso = parseInt(this.getAttribute('data-vg-paso'), 10) || 6;
        this.pintarMas();
      }

      ocultas() {
        return this.items.filter(function (li) {
          return li.classList.contains('vg-resenas__item--mas') && !li.classList.contains('is-visible');
        });
      }

      pintarMas() {
        if (!this.botonMas) return;
        var quedan = this.ocultas().length;
        this.botonMas.hidden = quedan === 0;
        var n = this.botonMas.querySelector('[data-vg-quedan]');
        if (n) n.textContent = String(quedan);
      }

      verMas() {
        var lote = this.ocultas().slice(0, this.paso);
        lote.forEach(function (li) {
          li.classList.add('is-visible');
        });
        this.pintarMas();
        if (lote[0]) enfocar(lote[0].querySelector('[data-vg-tarjeta]'));
      }

      /* Carrusel (< 990 px): contador y flechas. El arrastre con ratón lo pone vestigium-interaccion.js */
      iniciarCarrusel() {
        var controles = this.querySelector('[data-vg-controles]');
        if (!this.lista || !controles || this.items.length < 2) return;
        this.actual = controles.querySelector('[data-vg-actual]');
        this.anterior = controles.querySelector('[data-vg-anterior]');
        this.siguiente = controles.querySelector('[data-vg-siguiente]');
        controles.hidden = false;

        var raf = 0;
        var pedir = () => {
          if (raf) return;
          raf = requestAnimationFrame(() => {
            raf = 0;
            this.pintarCarrusel();
          });
        };
        var lista = this.lista;
        lista.addEventListener('scroll', pedir, { passive: true });
        window.addEventListener('resize', pedir, { passive: true });
        var quitarMq = escucharMq(mqEscritorio, pedir);
        this.vgLimpiar.push(function () {
          lista.removeEventListener('scroll', pedir);
          window.removeEventListener('resize', pedir);
          quitarMq();
          if (raf) cancelAnimationFrame(raf);
        });
        this.pintarCarrusel();
      }

      pasoCarrusel() {
        var a = this.items[0];
        var b = this.items[1];
        var paso = a && b ? b.offsetLeft - a.offsetLeft : 0;
        return paso > 0 ? paso : this.lista.clientWidth;
      }

      pintarCarrusel() {
        if (!this.actual || mqEscritorio.matches) return;
        var lista = this.lista;
        var x = lista.scrollLeft;
        var max = lista.scrollWidth - lista.clientWidth;
        var ultimo = this.items.length - 1;
        var i = x >= max - 4 ? ultimo : Math.round(x / this.pasoCarrusel());
        i = Math.max(0, Math.min(ultimo, i));
        this.actual.textContent = String(i + 1);
        this.anterior.setAttribute('aria-disabled', String(x <= 4));
        this.siguiente.setAttribute('aria-disabled', String(x >= max - 4));
      }

      moverCarrusel(direccion) {
        var boton = direccion < 0 ? this.anterior : this.siguiente;
        if (!boton || boton.getAttribute('aria-disabled') === 'true') return;
        this.lista.scrollBy({
          left: direccion * this.pasoCarrusel(),
          behavior: conMovimiento() ? 'smooth' : 'auto',
        });
      }

      /* Muro (escritorio): cada tarjeta ocupa tantas filas de 2 px como mide. Mantiene el orden y no
         mueve las que ya se ven al pulsar «Ver más». Si el navegador trae masonry nativo, no hace falta. */
      iniciarMuro() {
        if (!this.lista || !('ResizeObserver' in window)) return;
        if (window.CSS && CSS.supports && CSS.supports('grid-template-rows', 'masonry')) return;
        var raf = 0;
        var pedir = () => {
          if (raf) return;
          raf = requestAnimationFrame(() => {
            raf = 0;
            this.calcularMuro();
          });
        };
        var ro = new ResizeObserver(pedir);
        this.items.forEach(function (li) {
          ro.observe(li);
        });
        var quitarMq = escucharMq(mqEscritorio, pedir);
        this.vgLimpiar.push(function () {
          ro.disconnect();
          quitarMq();
          if (raf) cancelAnimationFrame(raf);
        });
      }

      calcularMuro() {
        if (!mqEscritorio.matches) {
          this.classList.remove('vg-resenas--muro');
          return;
        }
        var visibles = this.items.filter(function (li) {
          return li.offsetParent !== null;
        });
        // offsetHeight no cambia con los transform del revelado ni de la inclinación
        var alturas = visibles.map(function (li) {
          return li.offsetHeight;
        });
        visibles.forEach(function (li, i) {
          li.style.gridRowEnd = 'span ' + Math.max(1, Math.ceil(alturas[i] / 2));
        });
        this.classList.add('vg-resenas--muro');
      }

      /* Foto en grande. Esc la cierra (nativo), igual que la X o pulsar fuera de la foto. */
      iniciarFotos() {
        var dialogo = this.querySelector('[data-vg-dialogo]');
        if (!dialogo || typeof dialogo.showModal !== 'function') return;
        this.dialogo = dialogo;
        this.dialogoPie = dialogo.querySelector('[data-vg-dialogo-pie]');
        var figura = dialogo.querySelector('[data-vg-dialogo-figura]');
        var img = figura.querySelector('img');
        if (!img) {
          img = document.createElement('img');
          img.decoding = 'async';
          img.alt = '';
          figura.insertBefore(img, figura.firstChild);
        }
        this.dialogoImg = img;

        var alCerrar = () => {
          var origen = this.origenFoto;
          this.origenFoto = null;
          if (origen && origen.isConnected) enfocar(origen);
        };
        dialogo.addEventListener('close', alCerrar);
        this.vgLimpiar.push(() => {
          dialogo.removeEventListener('close', alCerrar);
          if (dialogo.open) dialogo.close();
          this.dialogo = null;
        });
      }

      abrirFoto(enlace) {
        var img = this.dialogoImg;
        var ancho = parseInt(enlace.getAttribute('data-vg-ancho'), 10);
        var alto = parseInt(enlace.getAttribute('data-vg-alto'), 10);
        img.removeAttribute('srcset');
        img.removeAttribute('src');
        if (ancho > 0 && alto > 0) {
          img.width = ancho;
          img.height = alto;
        } else {
          img.removeAttribute('width');
          img.removeAttribute('height');
        }
        img.alt = enlace.getAttribute('data-vg-alt') || '';
        img.sizes = '(min-width: 990px) 72vw, 94vw';
        var srcset = enlace.getAttribute('data-vg-srcset');
        if (srcset) img.srcset = srcset;
        img.src = enlace.getAttribute('href');
        if (this.dialogoPie) this.dialogoPie.textContent = enlace.getAttribute('data-vg-pie') || 'Foto de la reseña';
        this.origenFoto = enlace;
        this.dialogo.showModal();
      }

      alternarTexto(boton) {
        var texto = document.getElementById(boton.getAttribute('aria-controls'));
        if (!texto) return;
        var abrir = boton.getAttribute('aria-expanded') !== 'true';
        boton.setAttribute('aria-expanded', String(abrir));
        texto.classList.toggle('is-abierto', abrir);
        var rotulo = boton.querySelector('[data-vg-leer-texto]');
        if (rotulo) rotulo.textContent = abrir ? 'Leer menos' : 'Leer entera';
      }
    }

    window.customElements.define('vg-resenas', VgResenas);
  })();

  } catch(e) { console.error(e); }
})();
})();
